// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { sketchpad as _sketchpad } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the sketchpad chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 984123
 * Chain Name: Forma Sketchpad
 * Default Block Explorer: https://explorer.sketchpad-1.forma.art
 * Default RPC URL: https://rpc.sketchpad-1.forma.art
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { sketchpad } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: sketchpad,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const sketchpad = createCommon({
	..._sketchpad,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
